// extracted by mini-css-extract-plugin
module.exports = {"contact":"Contact_contact__3nKSK","icon":"Contact_icon__1rC_M"};